import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import { grey } from '@material-ui/core/colors';


import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Typography} from '@material-ui/core'
import {Button, FormControl, Checkbox} from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';

import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getObjectByID } from '../../../api/helpers';

class SelectExternalNetworkGroupDialog_ extends React.Component{

    constructor(props){
        super(props)

        this.state = {
            changed: false,
            panelsExpanded: {},
            selected : {
                DMRNetworkID: this.props.DMRNetworkID,
                DMRGroupID: this.props.DMRGroupID,
                DMRSlot: this.props.DMRSlot
            },
            errors: {}
        }
    }

    handleSelect(){
        if(this.validate()){
            this.props.onAction({type: 'SELECT_DMR_GROUP_DIALOG_SELECT', ...this.state.selected })
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'SELECT_DMR_GROUP_DIALOG_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'SELECT_DMR_GROUP_DIALOG_CLOSE'})
        }
    }

    handleInput(event){
        let changed = {}
        if(!this.state.changed) changed = {changed: true}

        let arr = event.target.name.split('_')
        let i = arr[1]

        let permissions = this.state.permissions
        permissions[i] = event.target.checked?1:0

        this.setState({permissions: permissions, ...changed})
    }

    validate(){
        //let errors = this.state.errors;
        let error = false
  /*   
        if(!this.state.group.Name){
            errors.Name = 'Name is empty'
            error = true
        }else{
            errors.Name = false
        }
        this.setState({errors: errors})
*/
        return !error;
    }


    togglePanel(event, expanded, panel){
        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })
    }

    isSelected(netID, groupID, slot){
        console.log('isSelected')
        console.log(this.state.selected)
        console.log(netID)
        console.log(groupID)
        console.log(slot)

        let selected = this.state.selected

        let isSelected = 
                netID === selected.DMRNetworkID && 
                groupID === selected.DMRGroupID && 
                slot === selected.DMRSlot

         return isSelected
    }


    getRowStyle(netID, groupID, slot){
        let style = {
            background: this.isSelected(netID, groupID, slot) ? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    select(netID, groupID){
        let network = getObjectByID(netID, this.props.externalNetworks)
        let group = getObjectByID(groupID, network.Groups)

        this.setState({selected: {
            DMRNetworkID: netID,
            DMRGroupID: group.GroupID,
            DMRSlot: group.Slot
        }})
    }

    selectClose(netID, groupID){
        let network = getObjectByID(netID, this.props.externalNetworks)
        let group = getObjectByID(groupID, network.Groups)

        let selected = {
            DMRNetworkID: netID,
            DMRGroupID: group.GroupID,
            DMRSlot: group.Slot
        }

        if(this.validate()){
            this.props.onAction({type: 'SELECT_DMR_GROUP_DIALOG_SELECT', ...selected })
        }
    }


    render(){
        const {t} = this.props


        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            icon:{
                width: 30
            },
            addIcon: {
                color: 'white'
            }
        };

        const title = t('SelectItem')

        const margin = {margin:'16px 0 8px 0'}

        console.log('render SelectExternalNetworkGroupDialog')
        console.log(this.props)

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>          

            {this.props.externalNetworks.map(net=>(

            <ExpansionPanel key={net.ID}
                expanded={this.state.panelsExpanded[net.ID]==undefined?true:this.state.panelsExpanded[net.ID]} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, net.ID)}>
                <ExpansionPanelSummary style={{background: grey[300]}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{net.Name}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block', margin:0, padding:0}}>
                    
                    <Table size="small">

                    <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>{t('Name')}</TableCell>
                                <TableCell style={{...styles.head, width:100}}>{t('GroupID')}</TableCell>
                                <TableCell style={{...styles.head, width:100}}>{t('Slot')}</TableCell>
                            </TableRow>
                        </TableHead>
                    
                    <TableBody>
                    {net.Groups.map(group=>
                    <TableRow key={group.ID}  
                        onClick={event=>this.select(net.ID, group.ID)}
                        onDoubleClick={event=>this.selectClose(net.ID, group.ID)}
                        style={this.getRowStyle(net.ID, group.GroupID, group.Slot )}>
                        <TableCell>
                            {group.Name}
                        </TableCell>
                        <TableCell>
                            {group.GroupID}
                        </TableCell>
                        <TableCell>
                            {group.Slot}
                        </TableCell>
                    </TableRow>
                    )}
                    </TableBody>
                    </Table>

                </ExpansionPanelDetails>
            </ExpansionPanel>
            ))}

            

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSelect.bind(this)} variant="contained" color="primary">
            {t('Select')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const SelectExternalNetworkGroupDialog = withTranslation()(SelectExternalNetworkGroupDialog_);